// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import React, { useCallback } from 'react'
import { string } from 'prop-types'
import { useDispatch } from 'react-redux'
import { reInitializeForm } from '../../common'
import { UpdatedLabeledRadioGroup } from 'components/Form'
import { ProjectStatusIdEnum } from 'config/enums'

import {
  Field,
  submit,
} from 'redux-form'

// This is the radio group which is seen on the project management search form,
// allowing the user to search for 'active' or 'finalized' projects.
// 'active' meaning In Progress or Pending
// and 'finalized' meaning Finalized.

const options = [{
  label: 'Active',
  value: `${ProjectStatusIdEnum.IN_PROGRESS},${ProjectStatusIdEnum.PENDING}`,
}, {
  label: 'Finalized',
  value: `${ProjectStatusIdEnum.FINALIZED}`,
}]

const ProjectStatus = ({ idRoot, sourceForm }) => {
  const dispatch = useDispatch()

  const onChangeCustom = useCallback(async (e, c) => {
    // propagate the change event to redux-form
    await c(e)

    // initializing the form sets it to pristine so that the pagination can display
    await dispatch(reInitializeForm(sourceForm))

    // trigger the form to submit
    return dispatch(submit(sourceForm))
  }, [])

  return (
    <Field
      idRoot={`${idRoot}project-status-`}
      className={'project-status radio-size-lg'}
      component={UpdatedLabeledRadioGroup}
      label={'Project Status'}
      name={'projectStatusId'}
      onChangeCustom={onChangeCustom}
      options={options} />
  )
}

ProjectStatus.propTypes = {
  idRoot: string.isRequired,
  sourceForm: string.isRequired,
}

export default ProjectStatus
